import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// ========================
// REQUEST INTERCEPTOR
// ========================
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// ========================
// RESPONSE INTERCEPTOR
// ========================
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("loginTime");

      alert("Session expired. Please login again.");

      window.location.href = "/login";
    }

    return Promise.reject(error);
  },
);

// ========================
// HELPERS
// ========================

export const fetchDataFromApi = async (url) => {
  try {
    const { data } = await API.get(url);
    return data;
  } catch (error) {
    return error.response?.data || { error: true, msg: "Server error" };
  }
};

export const postFeilds = async (url, body) => {
  try {
    const { data } = await API.post(url, body);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const editFeilds = async (url, body) => {
  try {
    const { data } = await API.put(url, body);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const editData = async (url, formData) => {
  try {
    const { data } = await API.put(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const postData = async (url, formData) => {
  try {
    const { data } = await API.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const deleteData = async (url) => {
  try {
    const { data } = await API.delete(url);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const deleteImages = deleteData;
